import React from 'react';
import Select, { MultiValue, Options } from 'react-select';

export type ComboBoxPropsType<T = DefaultDataType> = {
  data: Options<T>
  onChange: (arg: T[] | null, key: string) => void;
  keyId: string;
  mapLabels?: boolean;
  isMulti?: true | undefined;
  selectedItems?: T[]|null;
  menuIsOpen?: boolean;
  autoFocus?: boolean;
  menuListHeight?: number;
  isClearable?: boolean;
  placeholder?: string | React.ReactElement;
  disabled?: boolean;
};

export type DefaultDataType = {
  label: unknown;
  value: unknown;
  text?: string;
}

const ComboBox = <T extends DefaultDataType>(
  {
    data,
    onChange,
    keyId: uniqueKey,
    mapLabels,
    isMulti,
    selectedItems = [],
    menuIsOpen,
    autoFocus,
    menuListHeight,
    isClearable,
    placeholder,
    disabled,
  }: ComboBoxPropsType<T>,
): JSX.Element => {
  const mapValsOnLable = (e: MultiValue<T>): T[] | null | undefined => {
    if (!e) {
      return e;
    }
    const mappedVals: T[] = (e).map((el: T) => {
      if (el.label !== el.value) {
        return { ...el, label: el.value, text: el.label };
      }
      return { ...el, label: el.value };
    });
    return mappedVals;
  };

  const changeHandler = (e: MultiValue<T>) => {
    /**
     * ValueType is a type that gets changed by react-select based on the isMulti param
     * if isMulti is true we get an array, else we get an object in e.
     * This conditions make sure to convert single object to also an arary for the
     * sake of consistency
     */
    if (e && Array.isArray(e)) {
      const mappedVals = mapLabels ? mapValsOnLable(e) : e;
      onChange(mappedVals as T[] | null, uniqueKey);
    } else {
      let a = null;
      if (e !== null) {
        a = [];
        a.push(e);
      }
      onChange(a as T[] | null, uniqueKey);
    }
  };

  const customStyles = {
    menuList: (provided: any) => {
      if (menuListHeight) {
        return { ...provided, height: menuListHeight };
      }
      return { ...provided };
    },
    menu: (provided: any) => ({
      ...provided,
      zIndex: 2,
    }),
  };
  return (
    <Select
      styles={customStyles}
      options={data}
      onChange={changeHandler}
      value={selectedItems}
      isMulti={isMulti}
      menuIsOpen={menuIsOpen}
      autoFocus={autoFocus}
      isClearable={isClearable}
      placeholder={placeholder}
      isDisabled={disabled}
    />
  );
};

export default ComboBox;
